import type { Celebration } from './celebrationTypes'

// Pure FIFO queue reducer — kept free of React/DOM so it can be unit tested.

export interface CelebrationQueueState {
  current: Celebration | null
  pending: Celebration[]
}

export const initialQueueState: CelebrationQueueState = {
  current: null,
  pending: [],
}

export type CelebrationQueueAction =
  | { type: 'enqueue'; celebration: Celebration }
  | { type: 'advance' }

export function celebrationQueueReducer(
  state: CelebrationQueueState,
  action: CelebrationQueueAction
): CelebrationQueueState {
  switch (action.type) {
    case 'enqueue':
      if (!state.current) {
        return { current: action.celebration, pending: state.pending }
      }
      return { current: state.current, pending: [...state.pending, action.celebration] }
    case 'advance': {
      const [next, ...rest] = state.pending
      return { current: next ?? null, pending: rest }
    }
  }
}
